import { productOfficeConstants as C } from '../actions/constants'

const init = {
    mine: [],
    office: [],
    available: [],
    loading: false,
    bulkAdding: false,
    error: null,
    bulkAddError: null,
    message: null,
    bulkAddResult: null,
}

export default function productOffice(state = init, action) {
    switch (action.type) {
        case C.LIST_MINE_REQUEST:
        case C.LIST_OFFICE_REQUEST:
        case C.LIST_AVAILABLE_REQUEST:
        case C.CREATE_REQUEST:
        case C.UPDATE_REQUEST:
        case C.ARCHIVE_REQUEST:
        case C.TOGGLE_VISIBLE_REQUEST:
        case C.SHARE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.PRODUCT_OFFICE_BULK_ADD_REQUEST:
            return {
                ...state,
                bulkAdding: true,
                bulkAddError: null,
                bulkAddResult: null,
                message: null,
            }

        case C.LIST_MINE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                mine: action.payload,
            }

        case C.LIST_OFFICE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                office: action.payload,
            }

        case C.LIST_AVAILABLE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                available: action.payload,
            }

        case C.PRODUCT_OFFICE_BULK_ADD_SUCCESS:
            return {
                ...state,
                bulkAdding: false,
                bulkAddError: null,
                bulkAddResult: action.payload || null,
                message: action.payload?.message || 'Товары добавлены',
            }

        case C.CREATE_SUCCESS:
        case C.UPDATE_SUCCESS:
        case C.ARCHIVE_SUCCESS:
        case C.TOGGLE_VISIBLE_SUCCESS:
        case C.SHARE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: action.payload?.message || 'OK',
            }

        case C.PRODUCT_OFFICE_BULK_ADD_FAILURE:
            return {
                ...state,
                bulkAdding: false,
                bulkAddError: action.payload || 'Ошибка массового добавления',
                error: action.payload || 'Ошибка массового добавления',
            }

        case C.LIST_MINE_FAILURE:
        case C.LIST_OFFICE_FAILURE:
        case C.LIST_AVAILABLE_FAILURE:
        case C.CREATE_FAILURE:
        case C.UPDATE_FAILURE:
        case C.ARCHIVE_FAILURE:
        case C.TOGGLE_VISIBLE_FAILURE:
        case C.SHARE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload || 'Ошибка',
            }

        default:
            return state
    }
}